// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccountThumbnailsDataModel } from "@ces/App/Services/AccountThumbnailsService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type AccountThumbnailsStateModel = {
    data: AccountThumbnailsDataModel | null;
};

const initialState: AccountThumbnailsStateModel = {
    data: null,
};

const xAccountThumbnailsData = createTypedReducerWithImmer(initialState, {
    "xAccountThumbnails/CompleteLoadAccountThumbnailsData": (
        draft: Draft<AccountThumbnailsStateModel>,
        action: { accountThumbnailsData: AccountThumbnailsDataModel },
    ) => {
        draft.data = action.accountThumbnailsData!;
    },
});

(reducers as any).xAccountThumbnailsData = xAccountThumbnailsData;

export type xAccountThumbnailsData = {
    xAccountThumbnailsData: AccountThumbnailsStateModel;
} & ApplicationState;

type AccountThumbnailsDataReducer = {
    accountThumbnailsData: typeof xAccountThumbnailsData;
};

export type AccountThumbnailsDataActions =
    | Parameters<AccountThumbnailsDataReducer[keyof AccountThumbnailsDataReducer]>[1]
    | AnyAction;
